var React = require('react');

function Flipboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"}));
}

Flipboard.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Flipboard;

Flipboard.default = Flipboard;
